import { render, staticRenderFns } from "./AchievementRecord.vue?vue&type=template&id=135e8b4a&scoped=true&"
import script from "./AchievementRecord.vue?vue&type=script&lang=js&"
export * from "./AchievementRecord.vue?vue&type=script&lang=js&"
import style0 from "./AchievementRecord.vue?vue&type=style&index=0&id=135e8b4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135e8b4a",
  null
  
)

export default component.exports